export default (() => {
  return globalThis.navigator?.userAgent;
});